import { FC, useMemo } from 'react';
import { EasTable } from 'ui/EasTable';
import { TTableStructure } from 'ui/EasTable/types';
import { discountItemTableStructure } from './tableStructure';
import { TDiscountItemTableRow, TDiscountItemTableProps } from './types';

export const DiscountItemTable: FC<TDiscountItemTableProps> = ({ items, loading, currency }) => {
	const itemsWithCurrency: TDiscountItemTableRow[] = useMemo(
		() =>
			items.map((item) => ({
				...item,
				id: item.discount_id,
				payment_currency_code: currency,
			})),
		[items, currency],
	);

	const handleAction = () => {};

	return (
		<EasTable<TDiscountItemTableRow>
			tableStructure={
				discountItemTableStructure as TTableStructure<
					keyof TDiscountItemTableRow,
					TDiscountItemTableRow
				>[]
			}
			items={itemsWithCurrency}
			itemsIsLoading={loading}
			handleAction={handleAction}
		/>
	);
};
